import { MAX_PRODUCTS_PER_FILTERED_SECTION } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/DiscoverPageFilteredProductGrids/DiscoverPageFilteredProductGrids";
import { SearchPageExactProductResults } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/__internal__/SearchPageExactProductResults/SearchPageExactProductResults";
import { useSearchPageSlicedProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageSlicedProducts";
import { useSearchPageIrrelevantProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageIrrelevantProducts";
import { useSearchPageOrganicRelevanceClassification } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/DataFetching/Products/useSearchPageorganicRelevanceClassification";
import { useDiscoverPageShouldShowTopProducts } from "@faire/deprecated-retailer-visitor-shared/views/search-v2/util/useDiscoverPageShouldShowTopProducts";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { Spacer } from "@faire/web/slate/spacing";
import { useResponsiveValue } from "@faire/web/ui/hooks/useResponsiveValue";
import React from "react";

interface IProps {
  title: string;
  searchPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}

export const SearchPageProductResults: React.FC<IProps> = ({
  title,
  searchPageLoadTimingRef,
}) => {
  useTraceComponentRender("SearchPageProductResults");

  const products = useSearchPageSlicedProducts();
  const irrelevantProducts = useSearchPageIrrelevantProducts();
  const organicRelevanceClassification =
    useSearchPageOrganicRelevanceClassification();

  const itemsPerFilteredSection = useResponsiveValue(
    MAX_PRODUCTS_PER_FILTERED_SECTION
  );
  const shouldShowTopProducts = useDiscoverPageShouldShowTopProducts();
  const remainingProducts = shouldShowTopProducts
    ? products?.slice(itemsPerFilteredSection)
    : products;

  return (
    <>
      <SearchPageExactProductResults
        title={title}
        products={remainingProducts}
        irrelevantProducts={irrelevantProducts}
        organicRelevanceClassification={organicRelevanceClassification}
        searchPageLoadTimingRef={searchPageLoadTimingRef}
      />
      <Spacer height="1x" />
    </>
  );
};
